<script>
import WarningCard from "@/components/_Shared/Warnings/Card";
import Notice from "@/components/_Shared/Notices/Content";

import { mapActions, mapState } from "vuex";
import freshDesk from "@/utils/freshDesk";

export default {
  components: {
    WarningCard,
    Notice
  },

  methods: {
    openFreshdesk() {
      freshDesk.openProofOfPaymentForm();
    }
  }
};
</script>

<template>
  <warning-card>
    <notice
      icon="/static/proof-of-payment.svg"
      title="Quase lá... Agora é só confirmar o pedido!"
      subtitle="Você contratou a limpeza com menos de 48h de antecedência e selecionou boleto como forma de pagamento. Envie o comprovante de pagamento para confirmá-la."
    >
      <div @click="openFreshdesk" class="btn bg-pink-outline mt-10">enviar o comprovante</div>
    </notice>
  </warning-card>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Warnings/ProofOfPayment.vue